/**
 * @generated SignedSource<<66a175c53ec267931f0dcb085c1e2373>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedHeroModule_componentModule$data = {
  readonly cmsDisplayTitle: string | null;
  readonly items: ReadonlyArray<{
    readonly cmsId: number | null;
    readonly contemporaryTrackingString: string | null;
    readonly imageUrl: string | null;
    readonly itemId: string | null;
    readonly link: string | null;
    readonly title: string | null;
  } | null> | null;
  readonly title: string | null;
  readonly " $fragmentType": "HpSharedHeroModule_componentModule";
};
export type HpSharedHeroModule_componentModule$key = {
  readonly " $data"?: HpSharedHeroModule_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedHeroModule_componentModule">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedHeroModule_componentModule",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cmsDisplayTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "itemId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cmsId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "link",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contemporaryTrackingString",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HeroModule",
  "abstractKey": null
};
})();

(node as any).hash = "304883a2376a9628d2e8136901460bb1";

export default node;
